import { TranslationsContextProvider } from './TranslationsProvider';
import { useTranslations } from './useTranslations';

export { TranslationsContextProvider };

export default useTranslations;
